jQuery(document).ready(function($){
	console.log('Welcome to SquareCoda Theme!');

	let minContentHeight = window.innerHeight - $('#site-header').outerHeight() - $('#site-footer').outerHeight();
	if($('#wpadminbar').length) minContentHeight -= $('#wpadminbar').outerHeight();
	$('#content').css('min-height', minContentHeight + 'px');

	$('.sct-contact-form').each(function(){
		var formContent = $(this).attr('encoded-form');
		$(this).html(atob(formContent));
	});

	if($('body').hasClass('sticky-header')) {
		const headerHeight = $('#site-header').height();
		console.log(headerHeight);
		$('body').prepend('<style>:root{--scfe-sticky-footer-offset: ' + headerHeight + 'px;}</style>');
	}

	var links = document.getElementsByTagName('a');
	for(var i = 0; i < links.length; i++) {
		var hrefHostname = new URL(links[i].href).hostname;

		var matches = (hrefHostname == window.location.hostname || 'www.' + hrefHostname == window.location.hostname || hrefHostname == 'www.' + window.location.hostname);
		if(!matches) links[i].target = '_blank';
	}

	$('.sct-contact-form').on('submit', 'form', function(e){
		e.preventDefault();
		console.log('submitted');

		const el = $(this);

		data = {};
		$.each(el.serializeArray(), function(i, field){
			data[field.name] = field.value;
		});

		console.log(data);

		el.find('button').hide().after('<div class="sending-contact-email"><span class="fas fa-cog fa-spin"></span> Sending email...</div>');

		$.post('/wp-admin/admin-ajax.php', data, function(vars){
			console.log(vars);
			vars = JSON.parse(vars);
			el.find('.sending-contact-email').html('<div class="message ' + vars.status + '-message" style="margin: 0"><p>' + vars.message + '</p></div>');
			if(vars.status == 'success') {
				el.addClass('submitted');				
			}
		});
	});

	$('.sct-contact-form').on('click', 'form.submitted .send-again', function(){
		const form = $(this).closest('form.submitted');
		$(this).closest('.sending-contact-email').remove();
		form.removeClass('submitted').find('button').show();
		form.find('[name]:not([type="hidden"])').val('');
	});
});